export default "../images/stackloans-partners-with-suntrust-bank.png?dcd592e6bc2e1d8a706d02d44ce42e02";